import { Pagination } from '@/domain/entities/Pagination'

export class HomebannerData {
  private id: number
  private name: number
  private image: string
  private createdAt: string
  private updatedAt: string

  constructor(
    id: number,
    name: number,
    image: string,
    createdAt: string,
    updatedAt: string
  ) {
    {
      this.id = id
      this.name = name
      this.image = image
      this.createdAt = createdAt
      this.updatedAt = updatedAt
    }
  }
}

export class Homebanner {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: HomebannerData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: HomebannerData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
